import React from 'react'
import {Link} from 'react-router-dom'
import RegisterForm from './../common/register-form'

class Register extends React.Component{
	render(){
		return(
			<div className="About">
				<section class="contact-img-area">
		            <div class="container">
		                <div class="row">
		                    <div class="col-md-12 text-center">
		                        <div class="con-text">
		                            <h2 class="page-title">Register</h2>
		                            <p><a href="#">Home <i class="fa fa-angle-right"></i></a> Register</p>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </section>
		        <section class="design-area home-five" >
				  	<div class="container">
				  		<RegisterForm />		   
				  	</div>
				</section>
			</div>
			)
	}
}
export default Register;